import React from 'react';
import { PaymentForm } from '../components/PaymentForm';
export function PaymentRequests() {
  return <div data-id="element-8399">
      <PaymentForm data-id="element-8400" />
    </div>;
}